/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Field_Secondary_ColourInputs */

const en_field_secondary_colour = /** @type {(inputs: Field_Secondary_ColourInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Secondary colour`)
};

/**
* | output |
* | --- |
* | "Secondary colour" |
*
* @param {Field_Secondary_ColourInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const field_secondary_colour = /** @type {((inputs?: Field_Secondary_ColourInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Field_Secondary_ColourInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_field_secondary_colour(inputs)
});